export default {
	/**
	 *
	 * Development CONFIG (Dev)
	 *
	 */

	APIRoot: 'https://api.dev.drabayashi.net', // Dev
	ZAPIRoot: 'https://zapi.dev.drabayashi.net', // Dev
	APIPort: '443',
	SocketPort: '443',
	registrationRoot: 'https://register.dev.drabayashi.net',
	AppRoot: 'https://dte-app.dev.drabayashi.net',

	// 0 - Prod (Only log errors)
	// 1 - Log to Kafka
	// 2 - Log in console
	// 3 - Just plain crazy
	logDisplayLevel: 1,
	logSaveLevel: 1,
	logLimit: 1,
	logAppErrors: true,
	maxAjaxRetries: 1,

	namespace: 'register.dev.drabayashi.net',
	domain: 'reg',
	customTitle: '-',
	prefillWhitelist: {
		firstName: '#firstname-input',
		lastName: '#lastname-input',
		company: '#company-input',
		companySize: '#companysize-input',
		industry: '#industry-input',
		market: '#market-input',
		phone: '#phone-input',
		email: '#email-input',
		promo: '#promo-input',
		redirect: false
	},

	features: {
		auth: {
			disableStatusCheck: true,
			disableAPIKey: true
		},
		useV2Data: false,
		registration: false,
		sockets: false,
		emailConfirm: true,
		allowPlusInQueryString: true,

		cookies: {
			enabled: true,
			secure: false,
			register: 'DragonRegister',
			domain: 'drabayashi.net',
			geoDomainkey: 'DragonRegisterGeo'
		},

		integrations: {
			mixPanel: {
				enabled: true,
				passive: true,
				key: '13ed044f41a947f47908b2b309b42d2b'
			},
			intercom: {
				enabled: false,
				default: 'qftv3qdb', // for not logged in intercom
				passive: true // <- an integration token is not required to load this
			},
			zapier: {
				enabled: true,
				urls: {
					emailVerified: 'https://hooks.zapier.com/hooks/catch/819070/5lni00/',
					accountCreated: 'https://hooks.zapier.com/hooks/catch/819070/5lnipe/'
				}
			},
			googleAuth: {
				enabled: true,
				// OAUTH login
				apiKey: 'AIzaSyDdCfdFdI4clQZjtUO8rdII42fR1wW4EiI',
				scopes: [
					'https://www.googleapis.com/auth/plus.login',
					'https://www.googleapis.com/auth/userinfo.email'
				],
				clientId: '251306804784-mmsp3boj2fqd94hac3oevsergfk1co8i.apps.googleusercontent.com'
			},
			gtm: {
				enabled: false,
				key: 'GTM-TTNMHKK' // dev only
			},
			ga: {
				enabled: true,
				key: 'UA-77407195-3'
			}
		},
		ignoreConfirmEmail: true,
		ajaxMode: 'Axios',
		setViewTemplateUrlByJURI: true
	},

	debug: true, // add app to window etc

	throwErrors: true,
	whiteLabel: false,

	payments: {
		stripe: {
			HKG: 'pk_test_SIFUJZEk4803VP6DbuhoWc3Q',
			DEFAULT: 'pk_test_SIFUJZEk4803VP6DbuhoWc3Q' // <- required!!
		}
	},
	passwordValidation: 'required|min:14|max:100',
	freePlanName: 'NO-PAID-PRIMARY-PLAN'
};
